import { AnalyticSvc } from './../services/AnalyticSvc';
import {Strings} from '../Strings';
import {HttpSvcFactory} from '../services/HttpSvc';
import {AdSvc} from '../services/AdSvc';
import {OAuthCallbackSvc} from '../services/OAuthCallbackSvc';
import {Utils} from '../underscore-extensions';
import LightLandings from '../LightLandingPages';
import MediumLandings from '../MediumLandingPages';
import TemplateLandingPages from '../TemplateLandingPages';
import {
    animatronSettings,
    animatronTutorial,
    animatronEdu,
    animatronUserPage,
    animatronCompany,
    animatronEditorRedirect,
    animatronContractors,
    animatronPricing,
    animatronActivate,
    animatronRecoveryReset,
    animatronProjectAnalytics,
    animatronProject,
    animatronProjects,
    animatronSearchPage,
    animatronBannerBottom,
    animatronExplainerBottom,
    animatronLandingNewBottom,
    animatronContest,
    animatronPublish,
    animatronSpecialUpgrade,
    animatronMediumLanding,
    waveMain,
    animatronComparisonBottom,
    waveMyProjects,
    wavePricing,
    mainLanding,
    waveUserPage,
    waveLandingSMMW,
    mariSmithTutorials,
    salmaWebinars,
    animatronLandingTemplate,
    waveTutorialPage,
    animatronContestLanding,
    animatronContestDays,
    animatronSubscriptionPage,
    animatronSubscriptionSvc
} from '../lazy_modules'; //TODO use `import * as modules from 'lazy_modules'`;

import {
    setWrapper,
    setTitle,
    loadModule,
    redirect,
    redirectResolve,
    nullToEmptyString,
    redirectForLogin,
    extendState, trackVisit, createTrackVisit, onEnterTrackVisit
} from './RouteUtils';
import {AuthenticationSvc} from '../services/AuthenticationSvc';
import {AnimatronProjectsFactory} from '../services/AnimatronProjectsSvc';
import {LocalStorageSvc} from '../services/LocalStorageSvc';
import {TranslateSvc} from '../services/TranslateSvc';
import {SubscriptionSvc} from '../settings/services/SubscriptionSvc';
import { IStateParamsService } from 'angular-ui-router';
import getProductByDomain from '../helpers/getProductByDomain';

type Url = string | (() => string)

//TODO remove duplicate check anonymous
const replaceOnEnter = (domen: string, url?: Url) => ({
    onEnter() {
        const path = typeof url === 'function' ? url() : url || '';
        setTimeout(() => location.replace(`${domen}${path}${location.search}`), 0);
    }
});

const withRedirectToStudioReact = (url = '') => replaceOnEnter(`https://animatron${options.isProduction ? '' : '-test'}.com/studio/${url}`);

const withRedirectToReact = (url?: Url) => {
    return replaceOnEnter(
        `https://wave${options.isProduction ? '' : '-test'}.video/`, url
    );
};

class Routes {
    private static ENCODED_QUESTIONMARK = '%3f';

    constructor($stateProvider: ng.ui.IStateProvider,
                $urlRouterProvider: ng.ui.IUrlRouterProvider,
                $locationProvider: ng.ILocationProvider,
                $urlMatcherFactoryProvider: ng.ui.IUrlMatcherFactory) {
        $urlMatcherFactoryProvider.caseInsensitive(true);
        $urlRouterProvider.rule(($injector: ng.auto.IInjectorService, $location: ng.ILocationService): any => {
            const path = $location.url();
            // check to see if the path has a trailing slash
            if ('/' === path[path.length - 1]) {
                return path.replace(/\/$/, '');
            }

            return false;
        });

        $urlRouterProvider.rule(($injector: ng.auto.IInjectorService, $location: ng.ILocationService): any => {
            const path = $location.path();
            const pathsToRedirect = ['pricing', 'tutorial'];
            const isStudioUrl = /^\/studio/gi.test(path);
            const isRedirectPath = pathsToRedirect.some(redirectPath => new RegExp(`^/${redirectPath}`).test(path));

            const host = $location.host();
            const isStudioDomain = /animatron/gi.test(host);

            if (!isStudioUrl && isStudioDomain && isRedirectPath) {
                return `/studio${path}`;
            }
        });


        // extendState($stateProvider);

        const subscriptionModalsParams = ':modal?period&plan&redeem&promo&special&coupon';

        const tutorialResolve = _.extend(loadModule(animatronTutorial), setWrapper('wrapper-tutorial wrapper-long-head'));

        const projectsModules = loadModule(animatronProjects);

        const signUpState = {
            ...withRedirectToReact('signup')
        };

        const getLandingParams = () => ({
            url: '/studio?signup&loginRedirect',
            template: `<landing-page></landing-page>`,
            onEnter /*@ngInject*/($stateParams: ng.ui.IStateParamsService,
                analyticSvc: AnalyticSvc,
                $rootScope: ng.IRootScopeService,
                AuthenticationSvc: AuthenticationSvc) {
                createTrackVisit(analyticSvc, $rootScope)('Studio Main');

                const { loginRedirect } = $stateParams;
                if (loginRedirect) {
                    AuthenticationSvc.toggleLoginModal(decodeURIComponent(loginRedirect));
                }
            },
            resolve: _.extend(
                loadModule(animatronLandingNewBottom),
                setWrapper('wrapper-landing-common wrapper-landing-new'),
                setTitle())
        });

        const SMMWParams = ['utm_source', 'utm_medium', 'utm_campaign'].join('&');

        const SMMWPages: anm.WaveSMMWLandings[] = ['Image', 'Video'];

        $locationProvider.html5Mode(true).hashPrefix('!');
        $urlRouterProvider.otherwise(($injector: ng.auto.IInjectorService) => {
            const pth = location.pathname.toLowerCase();
            if (pth.includes(Routes.ENCODED_QUESTIONMARK)) {
                const regexp = new RegExp(Routes.ENCODED_QUESTIONMARK, 'gi');
                const [path, query] = location.pathname.split(regexp);

                location.href = path + '?' + query;
            } else {
                location.href = `${location.origin}/404`;
            }
        });
        $urlRouterProvider.when('', '/');
        $urlRouterProvider.when('/', () => location.reload());
        $urlRouterProvider.when('/studio/landing', '/studio');
        $urlRouterProvider.when('/wave/landing', '/wave');
        $urlRouterProvider.when('/cmw17', '/wave');
        $urlRouterProvider.when('/wave/?', ($location: ng.ILocationService) => {
            const url = $location.url().replace('/?', '?');
            $location.path(url).replace();
        });

        (function setupStates() {
            $stateProvider.state('wave-redirect', {
                url: `/wave`,
                params: {
                    eventPath: {
                        value: null,
                        raw: true,
                        squash: true
                    }
                },
                ...withRedirectToReact()
            })
            $stateProvider.state('calendar', {
                url: `/calendar/{eventPath:any}`,
                params: {
                    eventPath: {
                        value: null,
                        raw: true,
                        squash: true
                    }
                },
                ...withRedirectToReact(() => 
                    options.user.anonymous ? 'social-calendar' : 'calendar'
                )
            })
                .state('blog', {
                    url: '/blog/{path:any}',
                    params: {
                        path: {
                            value: null,
                            raw: true,
                            squash: true
                        }
                    },
                    onEnter($stateParams: ng.ui.IStateParamsService) {
                        const { path } = $stateParams;
                        const article = path ? `${path}/` : '';
                        location.replace(`https://www.animatron.com/blog/${article}`);
                    }
                })
                .state('mari-smith-tutorials', {
                    url: '/video-for-social-media-mari-smith',
                    template: '<mari-smith-tutorials />',
                    ...onEnterTrackVisit('Landing', {Name: 'Social Video Workshop by Mari Smith'}),
                    resolve: _.extend(
                        setTitle('wv.mari.page.title'),
                        loadModule(mariSmithTutorials()),
                        setWrapper('wrapper-landing-WAVE wrapper-landing-WAVE-webinar')
                    )
                })
                .state('video-marketing-strategy-salma-jafri', {
                    url: '/video-marketing-strategy-salma-jafri',
                    template: '<salma-webinars />',
                    ...onEnterTrackVisit('Landing', {Name: 'Video Strategy Workshop with Salma Jafri'}),
                    resolve: _.extend(
                        setTitle('wv.salma.title'),
                        loadModule(salmaWebinars()),
                        setWrapper('wrapper-landing-WAVE wrapper-landing-WAVE-webinar')
                    )
                })
                .state('wave2', {
                    url: `/wave-2?${SMMWParams}`,
                    noindex: true,
                    onEnter($location: ng.ILocationService,
                            $stateParams: ng.ui.IStateParamsService) {
                        const {utm_source, utm_medium, utm_campaign} = $stateParams;

                        const isSMMW = utm_source === 'SMExaminer'
                            && utm_medium === 'IndustryReport'
                            && utm_campaign === 'SMEad';

                        const SMMWPage = SMMWPages[_.random(1)];
                        if (isSMMW) {
                            const url = `/SMExaminerReport${SMMWPage}`;
                            $location.path(url).replace();
                        }
                    },

                    template: '<wave-landing></wave-landing>',
                    resolve: _.extend(loadModule(waveMain), setWrapper('wrapper-landing-WAVE'), setTitle('wv.landing.title'))
                })
                .state('user', {
                    url: '/users/:username',
                    params: {
                        folderId: {
                            value: null
                        }
                    },
                    noindex: true,
                    template: '<wave-user-page></wave-user-page>',
                    ...onEnterTrackVisit('Users'),
                    resolve: _.extend(
                        loadModule(waveUserPage),
                        setWrapper('wave-user-page-wrapper wrapper-wave-projects'),
                        setTitle(),
                        redirectResolve(() => !options.user.staff, '/wave')
                    )
                })
                .state('studio-user', {
                    url: '/studio/users/:username?startFollowing&customize&bgColor&page&removed',
                    params: {user: null},
                    noindex: true,
                    template: '<user-page></user-page>',
                    ...onEnterTrackVisit('Users'),
                    resolve: _.extend(
                        loadModule(options.enableContests ? animatronContest : animatronUserPage),
                        setWrapper('userpage-wrapper'),
                        setTitle()
                    )
                })
                .state('studio-following', {
                    url: '/studio/users/:username/following',
                    params: {user: null},
                    template: '<followers-page></followers-page>',
                    resolve: _.extend(
                        loadModule(animatronUserPage),
                        setWrapper('follow-wrapper'),
                        setTitle()
                    )
                })
                .state('studio-followers', {
                    url: '/studio/users/:username/followers',
                    params: {user: null},
                    template: '<followers-page></followers-page>',
                    resolve: _.extend(
                        loadModule(
                            animatronUserPage),
                        setWrapper('follow-wrapper'),
                        setTitle()
                    )
                })

                    // }).state('analytics', {
                    //     url: '/analytics?limit',
                    //     noindex: true,
                    //     controller: ($scope, $http, $stateParams, AnimatronProjects, HttpSvc, ProjectAugmenter, AnimatronPreviews) => {
                    //         const url = (options.isLocal ? 'http://localhost:8081' :
                    //                 ('https://' + (options.isProduction ? 'analytics.animatron.com' : 'analytics.animatron-test.com'))) +
                    //             '/analytics/projects';
                    //         $scope.animatron = new AnimatronProjects({});
                    //         $scope.animatron.nextPage = angular.noop;
                    //         $http.get(url).success((a: {count: number, _id: string}[]) =>
                    //             _.take(a, +$stateParams.limit)
                    //                 .forEach(p => HttpSvc('project', p._id).get().success((project: anm.Project) => {
                    //                     project.views = p.count;
                    //                     ProjectAugmenter(project);
                    //                     project.computedHeight = AnimatronPreviews.computeHeight(project.height, project.width, $scope.animatron.computedWidth);
                    //                     $scope.animatron.results.push(project);
                    //                 })
                    //             ));
                    //     },
                    //     templateUrl: require('projects.html'),
                    //     resolve: _.extend(setWrapper(''), projectsModules)
               
                .state('studio-explore', {
                    url: '/studio/explore?confirmationSent&login&isNew&page',
                    template: '<explore-page></explore-page>',
                    reloadOnSearch: false,
                    ...onEnterTrackVisit('Explore'),
                    resolve: _.extend(setWrapper('wrapper-explore'), setTitle('explore.title'), projectsModules, {})
                })
                .state('studio-search', {
                    url: '/studio/search?q&username&solr&myProjects&instant',
                    template: '<search-page></search-page>',
                    ...onEnterTrackVisit('Search'),
                    resolve: _.extend(setWrapper('wrapper-search'), setTitle(), loadModule(animatronSearchPage))
                })
                .state('tag', {
                    url: '/tags/:tag?super&user&page',
                    noindex: true,
                    controller: ($scope: any, $rootScope: ng.IRootScopeService, $stateParams: any, AnimatronProjects: AnimatronProjectsFactory) => {
                        const tag_type = _.findKey(_.omit($stateParams, 'tag'), (param: string) => param === 'true');
                        $rootScope.setTitle('tags.title', $stateParams.tag);
                        $scope.AdSvc = new AdSvc(false, $rootScope);
                        const adify = $scope.AdSvc.adify.bind($scope.AdSvc);
                        $scope.animatron = new AnimatronProjects({tag: $stateParams.tag, tag_type}, false, '', adify);
                    },
                    templateUrl: require('projects.html'),
                    resolve: _.extend(setWrapper(''), setTitle(), projectsModules)
                })
                .state('studio-tutorial', {
                    url: '/studio/tutorial/:video',
                    reloadOnSearch: false,
                    params: {
                        video: {value: null, squash: true}
                    },
                    template: '<tutorials-page></tutorials-page>',
                    ...onEnterTrackVisit('Tutorial'),
                    resolve: _.extend(setTitle('tutorial.title'), tutorialResolve)
                })
                .state('workshops', {
                    url: '/workshops',
                    template: '<wave-tutorial-page current-tab="workshops"></wave-tutorial-page>',
                    ...onEnterTrackVisit('Workshops'),
                    resolve: _.extend(
                        setTitle('tutorial.title'),
                        setWrapper('wrapper-wave-tutorials'),
                        loadModule(waveTutorialPage)
                    )
                })
                .state('tutorial', {
                    url: '/tutorial/:video',
                    reloadOnSearch: false,
                    params: {
                        video: {value: null, squash: true}
                    },
                    template: '<wave-tutorial-page></wave-tutorial-page>',
                    ...onEnterTrackVisit('Tutorial'),
                    resolve: _.extend(
                        setTitle('tutorial.title'),
                        setWrapper('wrapper-wave-tutorials'),
                        loadModule(waveTutorialPage)
                    )
                })
                .state('studio-education', {
                    url: '/studio/education',
                    template: '<education-page></education-page>',
                    ...onEnterTrackVisit('Education'),
                    resolve: _.extend(
                        loadModule(animatronEdu),
                        setWrapper('wrapper-long-head wrapper-edu'), 
                        setTitle('edu.title')
                        )
                })
                .state('studio-education.week', {
                    url: '/:week',
                    controller($scope: any, $stateParams: any, $rootScope: ng.IRootScopeService) {
                        $scope.week.number = parseInt($stateParams.week.substring(4), 10);
                        $rootScope.setTitle(`edu.week${$scope.week.number}.title`);
                    },
                    templateUrl: ($stateParams: any) => require(`education/${$stateParams.week}.html`)
                })
                .state('about', {
                    url: '/about',
                    noindex: true,
                    ...onEnterTrackVisit('About'),
                    resolve: _.extend(
                        redirectResolve(() => true, '/company')
                    )
                })
                .state('company', {
                    url: '/company/{tab}',
                    params: {
                        tab: {
                            value: null,
                            squash: true
                        }
                    },
                    template: '<company />',
                    ...onEnterTrackVisit('Company'),
                    resolve: _.extend(
                        loadModule(animatronCompany),
                        setWrapper('wrapper-press'),
                        setTitle('press.title')
                    )
                })
                .state('editor-redirect', {
                    url: '/editor-redirect',
                    template: '<editor-redirect></editor-redirect>',
                    resolve: _.extend(
                        loadModule(animatronEditorRedirect),
                        setWrapper('wrapper-landing-WAVE editor-redirect-page'),
                        setTitle('wv.landing.title')
                    )
                })
                .state('wave_signup', {
                    url: '/wave-signup',
                    onEnter($location: ng.ILocationService) {$location.path('/wave').replace(); }
                })
                .state('contractors', {
                    url: '/contractors',
                    template: '<contractors></contractors>',
                    ...onEnterTrackVisit('Contractors'),
                    resolve: _.extend(
                        loadModule(animatronContractors),
                        setWrapper('wrapper-contractors'),
                        setTitle('contractors.title')
                        )
                })
                .state('root', {
                    url: '/?signup&login&redirect_to',
                    template: '<main-landing />',
                    resolve: _.extend(
                        loadModule(mainLanding()),
                        setWrapper('wrapper-landing-common wrapper-simple-page'),
                        setTitle(''),
                        {
                            checkRedirect: /*@ngInject*/ ($location: ng.ILocationService) =>
                                redirect(!options.user.anonymous && $location.search().login, () =>
                                    $location.path('/login').replace()),
                            showModal: /*@ngInject*/($location: ng.ILocationService,
                                                     AuthenticationSvc: AuthenticationSvc,
                                                     LocalStorageSvc: LocalStorageSvc) => {
                                const redirect = $location.search().return_to || $location.search().login;
                                if (redirect) {
                                    AuthenticationSvc.loginModalShown = true;
                                    LocalStorageSvc.set('_animatron_redirect_onlogin', document.referrer);
                                }
                            }
                        })
                })
                .state('studio', getLandingParams())
                .state('landingWithAnimation', _.extend(getLandingParams(), {
                    noindex: true,
                    url: '/landing/:animation?signup'
                }))
                .state('studio-landing-banner', { //isolate scope will break it
                    url: '/studio/html5-banner-maker',
                    templateUrl: require('landing/banner.html'),
                    resolve: _.extend(
                        loadModule(animatronBannerBottom),
                        setWrapper('wrapper-landing-common wrapper-landing-banner'),
                        setTitle('banner.title'))
                })
                .state('studio-special-annual-upgrade', {
                    url: '/studio/special-annual-upgrade',
                    template: `<special-annual-upgrade></special-annual-upgrade>`,
                    resolve: _.extend(
                        redirectForLogin(),
                        loadModule(animatronSpecialUpgrade),
                        setWrapper('wrapper-special-annual-upgrade'),
                        setTitle('special.annual.upgrade.title'))
                })
                .state('studio-landing-explainer', {
                    url: '/studio/explainer-video-maker',
                    templateUrl: require('landing/explainer.html'),
                    resolve: _.extend(
                        loadModule(animatronExplainerBottom),
                        setWrapper('wrapper-landing-common wrapper-landing-banner wrapper-landing-explainer'),
                        setTitle('explainer.title'))
                })
                .state('studio-landing-political', {
                    url: '/studio/political-cartoon-maker',
                    controllerAs: '$ctrl',
                    controller(this: any, $rootScope: ng.IRootScopeService, $scope: ng.IScope, $sce: ng.ISCEService) {
                        const baseUrl = `https://videos.animatron.com/political_landing/political_cartoon${options.retina ? '_2x' : ''}`;
                        this.videoUrl = $sce.trustAsResourceUrl(`${baseUrl}.mp4`);
                        this.imgUrl = $sce.trustAsResourceUrl(`${baseUrl}.jpg`);
                        $rootScope.editorParams = '&guide=political';
                        $scope.$on('$destroy', () => $rootScope.editorParams = '');
                    },
                    templateUrl: require('landing/political-landing.html'),
                    resolve: _.extend(
                        setWrapper('wrapper-landing-common wrapper-landing-light wrapper-landing-political'),
                        setTitle('political.title')
                    )
                })
                .state('privacy', {
                    url: '/privacy',
                    ...withRedirectToReact('privacy')
                })
                .state('terms-of-service', {
                    url: '/terms-of-service',
                    ...withRedirectToReact('terms-of-service')
                })
                .state('studio-privacy', {
                    url: '/studio/privacy',
                    ...withRedirectToStudioReact('privacy')
                })
                .state('studio-terms-of-service', {
                    url: '/studio/terms-of-service',
                    ...withRedirectToStudioReact('terms-of-service')
                })
                .state('oauthDoLogin', {
                    url: '/oauth/{redirectUrl: any}',
                    params: {
                        redirectUrl: {
                            value: null,
                            raw: true,
                            squash: true
                        }
                    },
                    noindex: true,
                    template: '<div style="text-align: center">Authorization...</div>',
                    resolve: setTitle(),
                    onEnter: (
                        $stateParams: IStateParamsService,
                        LocalStorageSvc: LocalStorageSvc,
                        OAuthCallbackSvc: OAuthCallbackSvc
                    ) => {
                        const authLocalStoreName = 'auth';
                        const { redirectUrl } = $stateParams;

                        const authValue: any = LocalStorageSvc.get(authLocalStoreName);
                        LocalStorageSvc.remove(authLocalStoreName);

                        if (authValue) {
                            redirectUrl && LocalStorageSvc.set('_animatron_redirect_onlogin', redirectUrl);

                            OAuthCallbackSvc.doLogin(
                                authValue.params,
                                authValue.stateParams
                            );
                        }
                    }
                })
                .state('oauthCallback', {
                    url: '/callback/:provider/:product?code',
                    noindex: true,
                    resolve: setTitle(),
                    onEnter: ($stateParams: any, $location: ng.ILocationService, OAuthCallbackSvc: OAuthCallbackSvc) =>
                        OAuthCallbackSvc.onCallback($stateParams, $location.hash())
                })
                .state('404', {
                    url: '/404',
                    noindex: true,
                    httpStatus: '404',
                    ...withRedirectToReact('404')
                })
                .state('logout', {
                    noindex: true,
                    url: '/logout',
                    template: '<div></div>',
                    onEnter(AuthenticationSvc: AuthenticationSvc) {
                        AuthenticationSvc.logoutAndGoRoot();
                    },
                    resolve: setWrapper('.wrapper-ANY')
                })

                .state('project-analytics', {
                    url: '/project/{projectId}/analytics?rangeStart&rangeEnd',
                    noindex: true,
                    params: {project: null},
                    template: '<project-analytics></project-analytics>',
                    resolve: _.extend(loadModule(animatronProjectAnalytics), setWrapper('wrapper-analytics'), setTitle('analytics.title'))
                })
                .state('pages', {
                    url: '/pages',
                    noindex: true,
                    controller: ($state: ng.ui.IStateService) =>
                        document.querySelector('.main').innerHTML =
                            $state.get().map(s => `<a href="${$state.href(s.name, {})}">${s.name}</a><br>`).join('')
                })
                .state('project-likes', {
                    url: '/project/{projectId}/likes',
                    noindex: true,
                    params: {project: null},
                    template: `<a class="liker" style="text-align: center;"
                              ng-repeat="like in $ctrl.project.likes"
                              ui-sref="studio-user({username: (like.user.username | encodeUsername), user: like.user})"
                              ng-repeat="like in $ctrl.project.likes">
                                   <user-avatar user="like.user" size="45"></user-avatar>
                                   {{::like.user.displayName}}
                           </a>`,
                    controller: function (this: any, $stateParams: any, HttpSvc: HttpSvcFactory) {
                        HttpSvc('project', $stateParams.projectId)[options.user.anonymous ? 'get' : 'secureGet']()
                            .then((res: ng.IHttpPromiseCallbackArg<anm.Project>) => this.project = res.data);
                    },
                    controllerAs: '$ctrl',
                    resolve: _.extend(setWrapper(), setTitle())
                })
                .state('contest-page', {
                    url: '/contest/:contestId',
                    template: `<contest-page></contest-page>`,
                    resolve: _.extend(loadModule(animatronContest), setWrapper('contest-wrapper'), setTitle())
                })
                .state('contest-landing', {
                    url: '/makewaves',
                    template: `<contest-landing></contest-landing>`,
                    noindex: true,
                    resolve: _.extend(
                        loadModule(animatronContestLanding),
                        setWrapper('contest-landing-wrapper wrapper-hide-header wrapper-footer-small'),
                        setTitle('wv.contest-landing.pagetitle')
                    )
                })
                .state('contest-days', {
                    url: '/makewaves/:day?iv',
                    template: `<contest-days></contest-days>`,
                    noindex: true,
                    resolve: _.extend(
                        loadModule(animatronContestDays),
                        setWrapper('contest-landing-wrapper contest-days-wrapper wrapper-hide-header wrapper-footer-small'),
                        setTitle('wv.contest-landing.pagetitle')
                    )
                })
                .state('thanksgiving', {
                    url: '/thanksgiving',
                    noindex: true,
                    resolve: _.extend(
                        redirectResolve(() => true, '/wave')
                    )
                })
                .state('sharing', {
                    url: '/share/:tag',
                    noindex: true,
                    controllerAs: '$ctrl',
                    controller(this: any, $stateParams: any, AnimatronProjects: AnimatronProjectsFactory) {
                        this.animatron = new AnimatronProjects({
                            noCount: true,
                            limit: 5000,
                            tag: $stateParams.tag,
                            tag_type: 'SUPER',
                            previewWidth: 320
                        }, false, 'https://api.animatron.com');
                        this.animatron.nextPage();
                    },
                    templateUrl: require('project/publish/multi-share.html'),
                    resolve: _.extend(loadModule([animatronProjects, animatronPublish]), setWrapper(''), setTitle(''),
                        redirectResolve(() => !options.user.staff, '/landing'))
                })
                .state('wave-pricing', {
                    url: `/pricing/${subscriptionModalsParams}`,
                    params: {
                        modal: {
                            value: null,
                            squash: true
                        }
                    },
                    template: '<wave-pricing></wave-pricing>',
                    controller: ['$scope', function ($scope: any) {
                        $scope.alwaysShowFaq = true;
                        window.scrollTo(0, 0);
                    }],
                    ...onEnterTrackVisit('Pricing'),
                    resolve: _.extend(
                        setWrapper('wrapper-pricing wrapper-pricing-WAVE'),
                        loadModule(wavePricing),
                        setTitle('pricing.title')
                    )
                })
                .state('studio-pricing', {
                    url: `/studio/pricing/${subscriptionModalsParams}`,
                    params: {
                        modal: {
                            value: null,
                            squash: true
                        }
                    },
                    templateUrl: require('studio/pricing.html'),
                    controller: ['$scope', function ($scope: any) {
                        $scope.alwaysShowFaq = true;
                        window.scrollTo(0, 0);
                    }],
                    ...onEnterTrackVisit('Pricing'),
                    resolve: _.extend(
                        loadModule(animatronPricing),
                        setWrapper('wrapper-pricing'),
                        setTitle('pricing.title')
                    )
                })
                .state('my-projects', {
                    url: '/my-projects/{folderPath:any}?t&e',
                    params: {
                        folderPath: {
                            value: null,
                            raw: true,
                            squash: true
                        }
                    },
                    ...withRedirectToReact('videos')
                });

            SMMWPages.forEach((page) => {
                const state = page.toLowerCase();

                $stateProvider.state(`wave-landing-smmw-${state}`, {
                    url: `/SMExaminerReport${page}?${SMMWParams}`,
                    template: `<wave-landing-smmw view="'${page}'"></wave-landing-smmw>`,
                    ...onEnterTrackVisit('Landing', {Name: `SMExaminerReport${page}`}),
                    resolve: _.extend(
                        setTitle(),
                        loadModule(waveLandingSMMW),
                        setWrapper('wrapper-landing-WAVE-SMMW')
                    )
                });
            });


            ['video-templates', 'my-templates'].forEach((state) => {
                $stateProvider.state(state, {
                    url: `/${state}/{folderPath:any}`,
                    params: {
                        folderPath: {
                            value: null,
                            raw: true,
                            squash: true
                        }
                    },
                    ...withRedirectToReact('video-templates')
                });
            });

            ['affiliate-program', 'affiliate'].forEach((state) => {
                $stateProvider.state(state, {
                    url: `/${state}?${SMMWParams}`,
                    onEnter() {location.href = 'https://animatron.tapfiliate.com/publisher/signup/wave-affiliate-program'; }
                });
            });

            ['home', 'studio/home'].forEach((state) => {
                $stateProvider.state(state, {
                    url: `/${state}?login&isNew`,
                    controller($location: ng.ILocationService, $filter: ng.IFilterService) {
                        const redirectUrl = options.user.anonymous
                            ? '/studio'
                            : `/studio/users/${$filter('encodeUsername')(options.user.username)}`;

                        $location.path(redirectUrl);
                    }
                });
            });

            ['powtoon', 'goanimate', 'googlewebdesigner'].forEach((product) => {
                const state = `studio-${product}-landing-comparison`;
                const url = `/studio/${product}-vs-animatron`;

                $stateProvider.state(state, {
                    url: url,
                    params: {product},
                    template: `<landing-comparison-page></landing-comparison-page>`,
                    resolve: _.extend(
                        loadModule(animatronComparisonBottom),
                        setWrapper('wrapper-landing-comparison wrapper-landing-common'),
                        setTitle())
                });
            });

            options.animatronProducts.forEach((product) => {
                const productLower = product.toLowerCase();
                const [url, state] = product === 'WAVE' ? ['', ''] : [`${productLower}/`, `${productLower}-`];

                ['profile', 'subscription', 'password', 'notification'].forEach(s => {
                    const isSubscription = s === 'subscription';

                    const subscriptionState: ng.ui.IState = {
                            url: `/subscription/${subscriptionModalsParams}`,
                            params: {
                                modal: {
                                    value: null,
                                    squash: true
                                }
                            },
                            template: '<subscription-page></subscription-page>',
                            onEnter /*@ngInject*/ (analyticSvc: AnalyticSvc, $rootScope: ng.IRootScopeService) {
                                const visitPage = createTrackVisit(analyticSvc, $rootScope);
                                visitPage('Subscription');
                            },
                            resolve: _.extend(
                                loadModule(animatronSubscriptionPage()),
                                {
                                    cardDetails: /*@ngInject*/($ocLazyLoad: oc.ILazyLoad,
                                                               $injector: ng.auto.IInjectorService,
                                                               $q: ng.IQService) => {
                                        return animatronSubscriptionSvc()
                                            .then(m => $ocLazyLoad.load(m))
                                            .then<any>(() => {
                                                const subscriptionSvc = $injector.get<SubscriptionSvc>('subscriptionSvc');

                                                const readyLoadedData = subscriptionSvc.cardDetailsCashed
                                                    || subscriptionSvc.cardDetailsErrorMessage;

                                                return readyLoadedData
                                                    ? $q.resolve(readyLoadedData)
                                                    : subscriptionSvc.getCardDetails()
                                                        .catch(() => $q.resolve(true)); // needed for resolve it in any cases
                                            });
                                    }
                                }
                            )
                        }
                    ;

                    const defaultState = {
                        url: `/${s}`,
                        template: `<${s}></${s}>`,
                        onEnter /*@ngInject*/ (analyticSvc: AnalyticSvc, $rootScope: ng.IRootScopeService) {
                            const visitPage = createTrackVisit(analyticSvc, $rootScope);
                            visitPage(Strings.capitalize(s));
                        }
                    };
                    
                    $stateProvider.state(`${state}settings.${s}`, _.extend(
                        {noindex: true},
                        isSubscription ? subscriptionState : defaultState
                    ));
                });

                $stateProvider
                    .state(`${state}activate-email`, {
                        noindex: true,
                        url: `/${url}activate-email/:hash`,
                        onEnter($rootScope: ng.IRootScopeService,
                                $state: ng.ui.IStateService,
                                $stateParams: any,
                                HttpSvc: HttpSvcFactory,
                                AuthenticationSvc: AuthenticationSvc) {
                            HttpSvc('profile/confirm-email')
                                .securePost($stateParams.hash)
                                .then(r => r.data)
                                .then(res => {
                                    AuthenticationSvc
                                        .updateUser()
                                        .then(() => $state.go(`${state}settings.profile`));

                                    if (Utils.isApiError(res)) {
                                        _.notification.showError(res.message);
                                    } else {
                                        _.notification.showSuccess($rootScope.t('profile.updated'));
                                    }
                                });
                        },
                        resolve: _.extend(
                            redirectForLogin(),
                            setWrapper(`wrapper-${product}`)
                        )
                    })
                    .state(`${state}oauth-confirm`, {
                        noindex: true,
                        url: `/${url}signup/oauth/confirm/:hash`,
                        onEnter($rootScope: ng.IRootScopeService,
                                $state: ng.ui.IStateService,
                                $stateParams: any,
                                HttpSvc: HttpSvcFactory,
                                AuthenticationSvc: AuthenticationSvc) {
                            HttpSvc('signup/oauth/confirm', $stateParams.hash)
                                .post()
                                .then(r => r.data)
                                .then(res => {
                                    AuthenticationSvc
                                        .updateUser()
                                        .then(() => $state.go(`${state}settings.profile`));

                                    if (Utils.isApiError(res)) {
                                        _.notification.showError(res.message);
                                    } else {
                                        _.notification.showSuccess($rootScope.t('profile.updated'));
                                    }
                                });
                        },
                        resolve: _.extend(
                            redirectForLogin(),
                            setWrapper(`wrapper-${product}`)
                        )
                    })
                    .state(`${state}login`, {
                        url: `/${url}login?redirectUrl`,
                        params: {
                            redirectUrl: {
                                value: null,
                                raw: true,
                                squash: true
                            }
                        },
                        noindex: true,
                        template: '<login></login>',
                        onEnter: (
                            $stateParams: IStateParamsService,
                            analyticSvc: AnalyticSvc,
                            $rootScope: ng.IRootScopeService,
                            LocalStorageSvc: LocalStorageSvc
                        ) => {
                            createTrackVisit(analyticSvc, $rootScope)('Login');

                            const { redirectUrl } = $stateParams;
                            redirectUrl && LocalStorageSvc.set('_animatron_redirect_onlogin', redirectUrl);
                        },
                        resolve: _.extend(
                            setWrapper(`wrapper-${product} wrapper-long-head-login`),
                            setTitle('login.title'),
                            redirectResolve(() => !options.user.anonymous, (state === 'wave' ? 'wave/videos' : 'studio/explore'))
                        )
                    })

                    .state(`${state}recovery`,   {
                        url: `/${url}recovery?email`,
                        ...withRedirectToReact('recovery')
                    })

                    .state(`${state}recovery-reset`, {
                        url: `/${url}recovery/:hash`,
                        template: '<recovery-reset-page></recovery-reset-page>',
                        resolve: _.extend(
                            loadModule(animatronRecoveryReset),
                            setWrapper(`wrapper-activate`),
                            setTitle('recovery.reset.title')
                        )
                    })
                    .state(`${state}settings`, {
                        url: `/${url}settings`,
                        noindex: true,
                        controller: 'SettingsCtrl as settings',
                        templateUrl: require('settings/settings.html'),
                        resolve: _.extend(
                            redirectForLogin(),
                            loadModule(animatronSettings),
                            setWrapper(`wrapper-settings`),
                            setTitle()
                        )
                    })
                    .state(`${state}project`, {
                        url: `/${url}project/:projectId?staff&stopPlay`,
                        params: {project: null, stopPlay: null},
                        noindex: true,
                        template: '<project-page></project-page>',
                        ...onEnterTrackVisit('Project'),
                        resolve: _.extend(
                            setWrapper(`standalone-project `),
                            setTitle(),
                            loadModule(animatronProject)
                        )
                    })
                    .state(`${state}activate-oauth`, {
                        url: `/${url}activate-oauth?product`,
                        noindex: true,
                        template: '<activate-oauth></activate-oauth>',
                        resolve: _.extend(
                            redirectResolve(() => !options.user.social),
                            loadModule(animatronActivate),
                            setWrapper(`wrapper-activate`),
                            setTitle('activate.title')
                        )
                    })
                    .state(`${state}signup-with-redirect`, {
                        url: `/${url}signup/r/:email/:sendRequest/{redirectUrl: any}?product`,
                        params: {
                            email: {
                                value: null,
                                squash: true
                            },
                            sendRequest: {
                                value: null,
                                squash: true
                            },
                            redirectUrl: {
                                value: null,
                                raw: true,
                                squash: true
                            }
                        },
                        ...signUpState
                    })
                    .state(`${state}signup`, {
                        url: `/${url}signup?email&product&sendRequest&redirectUrl`,
                        ...signUpState
                    })
                    .state(`${state}activate`, {
                        url: `/${url}activate/:hash`,
                        noindex: true,
                        template: '<activate-email></activate-email>',
                        resolve: _.extend(
                            loadModule(animatronActivate),
                            setWrapper(`wrapper-activate`),
                            setTitle('activate.title')
                        )
                    });
            });

            ['detailed-views', 'views-count', 'summarized'].forEach(state => {
                $stateProvider.state(`project-analytics.${state}`, {
                    url: `/${Strings.toCamelCase(state)}?period`,
                    noindex: true,
                    template: `<${state}-analytics-directive></${state}-analytics-directive>`
                });
            });

            ['most-plays', 'recently-added', 'staff-picks', 'contest-submissions', 'my-projects'].forEach(state => {
                $stateProvider.state(`studio-explore.${state}`, {
                        url: `/${state}?page&product`,
                        noindex: state === 'my-projects',
                        resolve: _.extend(setWrapper('wrapper-explore'))
                    }
                );
            });

            const landingGenerator = (list: Array<anm.AbstractLanding>, kind: anm.LandingKind, ...resolveParams: Object[]) => {
                list.forEach(page => {
                    $stateProvider.state(page.url, {
                        url: '/' + page.url,
                        controller(this: any) {this.data = Object.assign({}, page); },
                        controllerAs: '$ctrl',
                        template: `<${kind}-landing data="$ctrl.data"></${kind}-landing>`,
                        resolve: _.extend(
                            setTitle(page.title),
                            setWrapper(`wrapper-landing-common wrapper-landing-${kind}`),
                            ...resolveParams
                        )
                    });
                });
            };

            TemplateLandingPages.forEach((landing: anm.LandingData) => {
                $stateProvider.state(landing.url, {
                    url: `/${landing.url}?t&d&iv&loginRedirect&${SMMWParams}`,
                    onEnter( $state: ng.ui.IStateService, $window: ng.IWindowService) {
                        $window.open(`https://www.animatron${options.isProduction ? '' : '-test'}.com/${landing.url}${location.search}`, '_self');
                    }
                });
            });

            landingGenerator(LightLandings, 'light');
            landingGenerator(MediumLandings, 'medium', loadModule(animatronMediumLanding));
        })();
    }
}

angular.module('animatronApp.routes', ['ui.router'])
    .config(Routes);



// WEBPACK FOOTER //
// ./app/assets/javascripts/routes/routes.ts